document.addEventListener("DOMContentLoaded", () => {
  let timeElapsed = 0;
  const maxTime = 5000;
  const intervalTime = 500;

  const checkProducts = setInterval(() => {
    const nsProducts = Array.from(document.querySelectorAll(".ns-product")).filter((product) => {
      const link = product.querySelector(".ns-details > a");
      return link && !link.href.includes("/collections/brands");
    });

    const isTouchDevice = window.matchMedia("(pointer: coarse)").matches;

    if (nsProducts.length > 0 && HTMLScriptElement.supports && HTMLScriptElement.supports("speculationrules")) {
      clearInterval(checkProducts);

      if (isTouchDevice) {
        // For touch devices: prerender first 12 product links
        const href_matches = nsProducts.slice(0, 12).map((product) => {
          const link = product.querySelector(".ns-details > a");
          return { href_matches: link.href };
        });

        const specScript = document.createElement("script");
        specScript.type = "speculationrules";
        specScript.textContent = JSON.stringify({
          prerender: [
            {
              source: "document",
              where: { or: href_matches },
              eagerness: "eager",
            },
          ],
        });
        document.head.appendChild(specScript);
      } else {
        // For desktop: hover triggers speculation rule
        nsProducts.forEach((product) => {
          product.addEventListener("mouseenter", () => {
            const link = product.querySelector(".ns-details > a");
            if (!link || !link.href) return;

            const specScript = document.createElement("script");
            specScript.type = "speculationrules";
            specScript.textContent = JSON.stringify({
              prerender: [
                {
                  source: "document",
                  where: { href_matches: link.href },
                  eagerness: "eager",
                },
              ],
            });
            document.head.appendChild(specScript);
          });
        });
      }
    }

    timeElapsed += intervalTime;
    if (timeElapsed >= maxTime) clearInterval(checkProducts);
  }, intervalTime);
});
